import { useContext } from 'react';
import { CreateEnterpriseContext } from '@enterprise/contexts/createEnterpriseContext';

const useCreateEnterprise = () => {
  const context = useContext(CreateEnterpriseContext);
  if (!context) {
    throw new Error(
      'useCreateEnterprise must be used within a  CreateEnterpriseProvider',
    );
  }
  return context;
};

export default useCreateEnterprise;
